import { useState, useEffect } from "react";
import { API_BASE_URL } from "../../utils/constants";

/**
 * Custom hook to fetch paginated data with auto-refresh every 60 seconds
 */
const usePaginatedFetch = (endpoint, initialParams = {}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(initialParams.page || 1);
  const [hasNextPage, setHasNextPage] = useState(true);

  const fetchData = async (showLoading = true) => {
    if (showLoading) setLoading(true);
    setError(null);
    try {
      const url = new URL(`${ API_BASE_URL }${ endpoint }`);
      if (initialParams) {
        Object.entries({ ...initialParams, page }).forEach(([key, value]) => {
          if (value !== null && value !== undefined) {
            url.searchParams.append(key, value);
          }
        });
      }

      const response = await fetch(url, {
        timeout: 60000 // 60 seconds timeout
      });
      if (!response.ok) throw new Error(`HTTP Error: ${ response.status }`);

      const result = await response.json();
      setData(result);
      setHasNextPage(result.length === initialParams.limit); // If limit reached, assume more pages exist
    } catch (err) {
      setError(err);
    } finally {
      if (showLoading) setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();

    const interval = setInterval(() => fetchData(false), 60000); // Auto-refresh every 60 seconds without loading indicator
    return () => clearInterval(interval);
  }, [endpoint, page, JSON.stringify(initialParams)]);

  return { data, loading, error, page, setPage, hasNextPage };
};

export default usePaginatedFetch;
